import React, { useEffect,useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import {LoginPopupStyles }from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import { setUserBrandAddAction, setUserBrandDelAction} from '../../modules/common/brandModule';
import { setClipBrandIdAction} from '../../modules/su/userBrandModule';
import { remove } from 'lodash';
import { useHistory } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';

const SearchBrandHomeItemBlock = styled.div`
      ${isMobileOnly&&`
        margin: 20px;
        display: flex;
        flex-direction: column;
      .rb-fc_box {
        height: unset;
       
      }              
      `};           
`;

const SearchBrandHomeItemLeftBlock = styled.div`
    cursor : pointer;
    margin-top: 6px;
    height : 28px;
    ${isMobileOnly&&`
        display:flex;
        justify-content: center;
    `};
`;

const SearchBrandHomeItemLeftImgBlock = styled.img`
    height : 28px;
`;

const SearchBrandHomeItemBrandNameBlock = styled.span`
`;

const SearchBrandHomeItemRightBlock = styled.div`
`;

const SearchBrandHomeItemBottomBoxBlock = styled.div`
    ${isMobileOnly&&`
        display:flex;
        justify-content: center;
        margin-top: 1rem;
    `};
   /*  position: absolute;
    bottom: 0;
    left: 0;
    height: 40px;
    overflow: hidden;
    font-family: Montserrat,sans-serif;

    ::after {
        content: '';
        display: block;
        clear: both;
    } */
`;

const SearchBrandHomeItemBottomBoxHomeLinkBlock = styled.div`
    float: left;
    width: 227px;
    height: 40px;
    padding: 11px 13px 10px;
    margin-right: 8px;
    color: #fff;
    background-color: #111;
    text-align: center;
    font-size: 14px;
    display: inline-block;
    border-radius: 4px;
    cursor: pointer;

    ::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 11px;
        margin-left: 10px;
        background: url(/assets/images/icon/btn_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

const SearchBrandHomeItemBottomBoxLikeBtBlock = styled.button`
    float: left;
    background: ${props => props.btnUrl};

    width: 40px;
    height: 40px;
    border-radius: 4px;
`;
const new2 = "NEW ";
const Home = "BRAND HOME"

//Modal.setAppElement('#modal-root');

const SearchBrandHomeItem = ({img, brandInfo, total, idHome, isDefault = true}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [isClipAdd, setIsClipAdd] = useState(false);
    const [isClipDel, setIsClipDel] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);
    const history = useHistory();
    //let date = new Date();
    //let date1 = new Date(brInfo._source.reg_dtm)

    //let diffDay = (date.getTime()-date1.getTime())/(1000*60*60*24)
    //console.log("diffDay = "+diffDay);

    const { accessToken ,clipBrandIds, brandClipResult, id, searchText} = useSelector(
        ({ userReducer, brandItemsReducer, userBrandReducer, searchReducer }) => ({
            accessToken: userReducer.accessToken,
            clipBrandIds: userBrandReducer.clipBrandIds,
            brandClipResult: brandItemsReducer.brandClipResult,
            id: userReducer.id,
            searchText: searchReducer.searchText,
        })
    );

    useEffect(() => {
        if(accessToken !== null){
            onCloseModal();
        }

        return ()=>{
            //console.log( "SearchBrandHomeItem end = ");
        };

    }, [accessToken]);

    useEffect(() => {

        //console.log("SearchBrandHomeItem" + JSON.stringify(clipBrandIds))

        if(isClipAdd){
            if(clipBrandIds === null || clipBrandIds === undefined || (clipBrandIds && clipBrandIds.length < 1)){
                let clipSum = [];
                clipSum.push(idHome);
                //console.log("SearchBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipAdd(false);
            }
            else{
                let clipSum = [...new Set(clipBrandIds.concat(idHome))];
                //console.log("SearchBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipAdd(false);
            }
        }
        else if(isClipDel){
            if(clipBrandIds != null){
                let clipSum = [...clipBrandIds];
                remove(clipSum,(obj)=>{return obj === idHome})
                //console.log("SearchBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipDel(false);
            }
        }

    }, [brandClipResult]);

    //로그인 팝업 뜨고 로그인 완료 후, 좋아요 리스트 요청(메인화면에서 요청) 후 처리.
    useEffect(() => {
        if(accessToken !== null && fromLoginPU === true){

            //로그인 완료 후 이미 좋아요 포함되어 있는 경우 요청하지 않음.
            if(clipBrandIds != null && clipBrandIds.length >0 && clipBrandIds.includes(idHome)){

            }
            else{

                dispatch(setUserBrandAddAction(id,idHome));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
            setFromLoginPU(false);
        }

    }, [clipBrandIds]);

    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setOpenModal(false);
    }

    const onHandleLike = (idHome) =>{
        //비로그인
        if (accessToken === null){
            onOpenModal();
            setFromLoginPU(true); //로그인 팝업 후, 종료시 다시 요청하기 위해서..
        }
        else{
            if(clipBrandIds != null && clipBrandIds.length >0 && clipBrandIds.includes(idHome)){
                dispatch(setUserBrandDelAction(id,idHome));
                setIsClipAdd(false);
                setIsClipDel(true);
            }
            else{
                dispatch(setUserBrandAddAction(id,idHome));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
        }

    }

    const getLikeBtn = () => {
        //비로그인
        if(accessToken === null){

            return "url(/assets/images/icon/bookmark-icon.png) center center/cover no-repeat"
        }
        else{
            if(clipBrandIds != null && clipBrandIds.length >0 && clipBrandIds.includes(idHome)){
                return "url(/assets/images/icon/bookmark-icon-active.png) center center/cover no-repeat"
            }
            else{
                return "url(/assets/images/icon/bookmark-icon.png) center center/cover no-repeat"
            }

        }
        //return "url(/assets/images/icon/bookmark-icon-active.png) center center/cover no-repeat"
    }

    const handleBrandHome = (id) => {
        if(isDefault) {
            history.push("/brHome/" + id);
        } else {
            history.push("/brHome/" + id + "?q=" + searchText);
        }
        
    }
    return (
        <SearchBrandHomeItemBlock className = "sr-title margin_b-20 clearfix">
            <SearchBrandHomeItemLeftBlock onClick = {()=>handleBrandHome(idHome)} className = "f-left">
                <SearchBrandHomeItemLeftImgBlock src={img} alt=""/>
                <SearchBrandHomeItemBrandNameBlock className = "sr-brand">
                        {brandInfo}( <span>{total}</span> )
                </SearchBrandHomeItemBrandNameBlock>
            </SearchBrandHomeItemLeftBlock>
            <SearchBrandHomeItemRightBlock className = "rb-fc_box no_po f-right font-mont">
                <SearchBrandHomeItemBottomBoxBlock>
                    {/* <Link to={"/brHome/"+idHome}> */}
                        <SearchBrandHomeItemBottomBoxHomeLinkBlock onClick = {()=>handleBrandHome(idHome)}>
                                    {Home}
                        </SearchBrandHomeItemBottomBoxHomeLinkBlock>
                    {/* </Link> */}
                    <SearchBrandHomeItemBottomBoxLikeBtBlock onClick = {()=>onHandleLike(idHome)}
                    btnUrl = {getLikeBtn()}>

                    </SearchBrandHomeItemBottomBoxLikeBtBlock>
                </SearchBrandHomeItemBottomBoxBlock>
            </SearchBrandHomeItemRightBlock>
            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
                </Modal>
        </SearchBrandHomeItemBlock>
    );

};



export default SearchBrandHomeItem;
